type Props = Record<string, any>

const parts = ['requiredIndicator']

const baseStyle = (props: Props) => {
  return {
    requiredIndicator: {
      color: props.isInvalid ? 'red.500' : 'black',
    },
  }
}

export default {
  parts,
  baseStyle,
}
